import React from 'react';
import Box from "@mui/material/Box";

export { Poster };

function Poster() {
    return (
        <Box
            sx={{
                backgroundImage: "url('/assets/images/healthcare/web-poster.png')",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                height: '100vh',
            }}
        >
        </Box>
    );
}
